import { ReactNode } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Alert as AlertBox, AlertTitle } from "@material-ui/lab";

import theme from "theme";

interface AlertProps {
  bordered?: boolean;
  children?: ReactNode;
  severity?: "error" | "info" | "success" | "warning";
  title?: string;
}

const useStyles = makeStyles({
  root: {
    paddingBottom: theme.spacing(2),
    "& > div": {
      width: "100%",
    },
  },
});

const Alert = ({
  bordered = false,
  children,
  severity = "success",
  title,
}: AlertProps) => {
  const classes = useStyles();

  return (
    <AlertBox
      classes={{ root: classes.root }}
      icon={false}
      severity={severity}
      style={{
        color: "inherit",
        border: `${bordered ? "2px solid #2D9CDB" : "none"}`,
      }}
    >
      {!!title && (
        <AlertTitle>
          <strong style={{ fontWeight: theme.typography.fontWeightMedium }}>
            {title}
          </strong>
        </AlertTitle>
      )}
      {children}
    </AlertBox>
  );
};

export default Alert;
